<template>
  <div
    class="rounded bg-white p-3 shadow-normal shadow-gray-400 tablet:p-4 desktop:p-5"
  >
    <div class="flex min-h-[152px] w-full flex-col tablet:min-h-40">
      <figure v-if="imageUrl" class="mb-2 h-16 w-16">
        <img
          :src="imageUrl"
          :alt="title"
          loading="lazy"
          class="pointer-events-none block h-full w-full"
        />
      </figure>
      <div class="mb-2 grow tablet:mb-0">
        <p v-if="title" class="text-h4 mb-2 block">
          <strong class="line-clamp-2">{{ title }}</strong>
        </p>
        <p
          v-if="description"
          class="line-clamp-3 min-h-[60px] text-sm text-gray-600"
        >
          {{ description }}
        </p>
      </div>
      <TheArrowLink
        v-if="buttonName && buttonUrl"
        :id="buttonId"
        :to="buttonUrl"
        :title="buttonName"
        @click="$emit('click-callback')"
      >
        {{ buttonName }}
      </TheArrowLink>
    </div>
  </div>
</template>

<script setup lang="ts">
  interface IProps {
    title: string;
    description: string;
    buttonName?: string;
    buttonUrl?: string;
    buttonId?: string;
    imageUrl?: string;
  }

  withDefaults(defineProps<IProps>(), {
    title: '',
    description: '',
    buttonName: undefined,
    buttonUrl: undefined,
    buttonId: undefined,
    imageUrl: undefined,
  });

  defineEmits<{
    (e: 'click-callback'): void;
  }>();
</script>
